import { SurveyPropertiesValidationError } from 'app/custom-errors/SurveyPropertiesValidationError'
import { IStructureElements } from 'app/interfaces/IStructureElements'
import { ISurveyDef } from 'app/interfaces/ISurveyDef'
import { IQuestion } from 'app/interfaces/IQuestion'

export class SurveyDefPropertyValidator implements ISurveyDef {

  questions: Record<string, IQuestion>
  structureElements: IStructureElements
  title: Record<string, string>
  activeLang: string[]

  constructor(surveyDef: ISurveyDef) {
    this.questions = surveyDef.questions
    this.structureElements = surveyDef.structureElements
    this.title = surveyDef.title
  }

  validate() {

    const requiredProperties = Object.getOwnPropertyNames(this)
    let missingProperties: string[] = []
    for (const idx in requiredProperties) {
      if (this[requiredProperties[idx]] === undefined || this[requiredProperties[idx]] === null) {
        missingProperties.push(requiredProperties[idx])
      }
    }

    if (missingProperties.length) {
      throw new SurveyPropertiesValidationError().missingSurveyDef(missingProperties)
    }

  }
}
